export default __webpack_public_path__ + "static/media/person_designing_estate_plan.ba57308a.svg";